import { render, staticRenderFns } from "./view-appointment.vue?vue&type=template&id=01e9e3c0"
import script from "./view-appointment.vue?vue&type=script&lang=js"
export * from "./view-appointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports